import '../icon';
import '../icon-button';
import { defineCustomElement, getBooleanAttribute, getReactEventHandler, isAttrTrue, NectaryElement, updateBooleanAttribute, updateExplicitBooleanAttribute } from '../utils';
const templateHTML = '<style>:host{display:block;--sinch-global-size-icon:32px}#icon-dropdown{display:block;will-change:transform;transform:rotate(180deg)}:host([value]:not([value=false])) #icon-dropdown{transform:rotate(0)}</style><sinch-icon-button id="button" size="s"><sinch-icon id="icon-dropdown" slot="icon" name="keyboard_arrow_down"></sinch-icon></sinch-icon-button>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-segment-collapse', class extends NectaryElement {
  #$button;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$button = shadowRoot.querySelector('#button');
  }
  connectedCallback() {
    this.setAttribute('role', 'checkbox');
    this.#$button.addEventListener('click', this.#onClick);
    this.addEventListener('-change', this.#onChangeReactHandler);
  }
  disconnectedCallback() {
    this.#$button.removeEventListener('click', this.#onClick);
    this.removeEventListener('-change', this.#onChangeReactHandler);
  }
  static get observedAttributes() {
    return ['value'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'value':
        {
          updateExplicitBooleanAttribute(this, 'aria-checked', isAttrTrue(newVal));
          break;
        }
    }
  }
  set value(isChecked) {
    updateBooleanAttribute(this, 'value', isChecked);
  }
  get value() {
    return getBooleanAttribute(this, 'value');
  }
  get focusable() {
    return true;
  }
  focus() {
    this.#$button.focus();
  }
  blur() {
    this.#$button.blur();
  }
  #onClick = () => {
    const detail = !this.value;
    this.dispatchEvent(new CustomEvent('-change', {
      detail
    }));
  };
  #onChangeReactHandler = e => {
    getReactEventHandler(this, 'on-change')?.(e);
  };
});